import React, { ChangeEvent } from 'react';
import { Tabs as MaterialTabs } from '@material-ui/core';
import { useStyles } from './Container.styles';

export interface Props {
  ariaLabel?: string;
  value?: any;
  qaId?: string;
  onChange: (event: ChangeEvent<{}>, value: any) => void;
  className?: string;
  children?: React.ReactNode;
  centered?: boolean;
  variant?: 'fullWidth' | 'scrollable' | 'standard';
  orientation?: 'horizontal' | 'vertical';
}

const Tabs: React.FC<Props> = ({
  qaId,
  className,
  children,
  onChange,
  value,
  variant,
  orientation,
  centered,
  ariaLabel = 'tabs-container',
}: Props) => {
  const classes = useStyles();

  return (
    <MaterialTabs
      data-qa-id={qaId}
      classes={{
        indicator: classes.indicator,
      }}
      value={value}
      onChange={onChange}
      className={className}
      aria-label={ariaLabel}
      variant={variant}
      orientation={orientation}
      centered={centered}
    >
      {children}
    </MaterialTabs>
  );
};

export default Tabs;
